import component from './ko-KR/component';
import globalHeader from './ko-KR/globalHeader';
import menu from './ko-KR/menu';
import pages from './ko-KR/pages';
import pwa from './ko-KR/pwa';
import settingDrawer from './ko-KR/settingDrawer';
import settings from './ko-KR/settings';
import fixOverlay from './ko-KR/fix_overlay';
import fixOpenapi from './ko-KR/fix_openapi';
import fixAdminMisc from './ko-KR/fix_adminmisc';
import fixBilling from './ko-KR/fix_billing';
import fixComponents from './ko-KR/fix_components';
import fixConsoleMisc from './ko-KR/fix_consolemisc';
import fixGap from './ko-KR/fix_gap';
import fixSystemconfig from './ko-KR/fix_systemconfig';
import fixTenant from './ko-KR/fix_tenant';
import fixVoiceClone from './ko-KR/fix_voiceclone';
import fixTodo from './ko-KR/fix_todo';


export default {
  'navBar.lang': '언어',
  'layout.user.link.help': '도움말',
  'layout.user.link.privacy': '개인정보',
  'layout.user.link.terms': '약관',
  'app.preview.down.block': '이 페이지를 로컬 프로젝트로 다운로드',
  'app.welcome.link.fetch-blocks': '모든 블록 가져오기',
  'app.welcome.link.block-list': '기반 블록 개발을 사용하여 표준 페이지를 빠르게 구축',
  ...fixConsoleMisc,
  ...fixComponents,
  ...fixAdminMisc,
  ...fixBilling,
  ...fixTenant,
  ...fixVoiceClone,
  ...fixGap,
  ...fixSystemconfig,
  ...fixOpenapi,
  ...fixTodo,
};
